import { render, staticRenderFns } from "./element.vue?vue&type=template&id=4fc4ea00&scoped=true&"
import script from "./element.vue?vue&type=script&lang=js&"
export * from "./element.vue?vue&type=script&lang=js&"
import style0 from "./element.vue?vue&type=style&index=0&id=4fc4ea00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc4ea00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fc4ea00')) {
      api.createRecord('4fc4ea00', component.options)
    } else {
      api.reload('4fc4ea00', component.options)
    }
    module.hot.accept("./element.vue?vue&type=template&id=4fc4ea00&scoped=true&", function () {
      api.rerender('4fc4ea00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/blindBox/element.vue"
export default component.exports